angular.module('pipSideNav', ['ngMaterial', 'pipNav.Templates']);

import './SideNavState';
import './SideNavService';
import './SideNavPart';
import './SideNav';

export * from './SideNavService';